module.exports = __webpack_public_path__ + "static/Employees-84b2195e27fecc556ad9816db493b7a6.png";